import { Class, Resolver } from 'mediatr-ts'

import { IoCContainer } from '@writefull/core'

export class InversifyResolver implements Resolver {
  constructor(private readonly container: IoCContainer) {}
  public resolve<T>(type: Class<T>): T {
    return this.container.get(type)
  }

  public add<T>(type: Class<T>): void {
    this.container.bind(type).toSelf()
  }
}
